import { useEffect, useRef, useState } from 'react'

import { useCopyToClipboard } from '../../../../../hooks'
import { stopPropagation } from '../../../../../utils/events'
import { GRETA_COPY_FEEDBACK_TIMEOUT_MS } from '../../../GretaAIChat.constants'

export function useGretaAIChatCodeCopy(code) {
  const [copied, setCopied] = useState(false)
  const timerRef = useRef(null)

  function handleCopySuccess() {
    setCopied(true)

    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(
      () => setCopied(false),
      GRETA_COPY_FEEDBACK_TIMEOUT_MS
    )
  }

  const [, copy] = useCopyToClipboard({ onSuccess: handleCopySuccess })

  useEffect(() => () => clearTimeout(timerRef.current), [])

  function handleCopy(event) {
    stopPropagation(event)

    if (code) {
      copy(code)
    }
  }

  return { copied, handleCopy }
}
